<template>
    <div class="page__content extras">
        <h2 class="page__headline">
            {{ extras.length }} {{ $t('extras.headline') }}
        </h2>
        <div class="columns">
            <div class="column is-8">
                <p class="page__copy">
                    {{ $t('extras.copy') }}
                </p>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="tabs is-boxed">
                    <ul>
                        <li :class="{ 'is-active': tab == 0 }">
                            <router-link exact :to="{ name: 'extras', query: this.updateQuery({tab: 0}), params: {lang: lang} }" @click.native="tabChanged(0)">
                                <span class="icon is-small"><i class="fa fa-star"></i></span>
                                <span>{{ $t('extras.extras.title') }}</span>
                            </router-link>
                        </li>
                        <li :class="{ 'is-active': tab == 1 }">
                            <router-link exact :to="{ name: 'extras', query: this.updateQuery({tab: 1}), params: {lang: lang} }" @click.native="tabChanged(1)">
                                <span class="icon is-small"><i class="fa fa-exclamation-circle"></i></span>
                                <span>{{ $t('extras.mandatory.title') }}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <p v-if="tab == 0">{{ $t('extras.extras.copy') }}</p>
                <p v-if="tab == 1">{{ $t('extras.mandatory.copy') }}</p>
            </div>
        </div>


        <section class="extras__section extras-editor">
            <draggable class="columns is-multiline is-desktop" v-bind="dragOptions" v-model="extras" @end="onSortedEnd">
                <div class="column is-half-desktop" v-for="(extra, index) in extras" :key="extra.id">
                    <extra v-model="extras[index]" @del="openModal(index)" :mandatory="tab == 1"></extra>
                </div>
            </draggable>
        </section>

        <div class="is-clearfix">
            <a class="button is-primary is-pulled-left" @click="addExtra()" v-if="tab == 0">{{ $t('extras.addExtra.extra') }}</a>
            <a class="button is-primary is-pulled-left" @click="addExtra()" v-else>{{ $t('extras.addExtra.mandatory') }}</a>
            <router-link class="button is-pulled-right" exact :to="{ name: 'settings', params: {lang: lang} }" @click.native="nextStepClicked()">
                <span class="icon is-small">
                    <i class="fa fa-arrow-right" aria-hidden="true"></i>
                </span>
                <span>{{ $t('extras.editSettings') }}</span>
            </router-link>
        </div>

        <div class="modal isActive" :class="{ 'is-active': modal.isActive }">
            <div class="modal-background" @click="closeModal()"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ modal.title }}</p>
                    <button class="delete" @click="closeModal()"></button>
                </header>
                <section class="modal-card-body" v-html="modal.content">
                </section>
                <footer class="modal-card-foot is-clearfix">
                    <a class="button" @click="closeModal()">{{ $t('generic.cancel') }}</a>
                    <a class="button is-danger" @click="deleteExtra()">
                            <span class="icon">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </span>
                        <span>{{ $t('extras.delete') }}</span>
                    </a>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import {EventBus, Tracking} from '../../../utils';
    import {AppModel} from '../../../models';
    import {Api} from '../../../api';
    import {Extra} from '../../components';

    export default {
        name: 'extras',

        components: {
            draggable,
            Extra,
        },

        data() {
            return {
                extras: [],
                dragOptions: {
                    handle: '.edit-box__dragger',
                    ghostClass: 'sortable-ghost',
                },
                modal: {
                    isActive: false,
                    title: null,
                    content: null
                },
            };
        },
        computed: {
            tab() {
                return Number(this.$route.query.tab) || 0;
            },
            lang() {
                return AppModel.lang;
            }
        },
        beforeRouteEnter(to, from, next) {
            const mandatory = Number(to.query.tab) || 0;
            Api.bootstrap().then(function(response) {
                return Promise.all([response, Api.extras.fetchExtras({mandatory: mandatory})]);
            }).then(function(response) {
                next((vm) => {
                    vm.extras = response[1].body;
                });
            });
        },
        watch: {
            $route(newValue, oldValue) {
                if(newValue.query !== oldValue.query) {
                    this.fetchExtras();
                }
            },
        },
        methods: {
            updateQuery(update) {
                let query = Object.assign({}, this.$route.query);
                query = Object.assign(query, update);
                return query;
            },
            tabChanged(tabIndex) {
                Tracking.trackEvent('Extras', 'tabChanged', null, tabIndex);
            },
            fetchExtras() {
                Api.extras.fetchExtras({mandatory: this.tab}).then((response) => {
                    if(response.ok) {
                        this.extras = response.body;
                    }
                });
            },
            onSortedEnd() {
                let ordering = [];
                this.extras.forEach(function(element) {
                    ordering.push(element.id);
                });
                Api.extras.oderExtras({ 'order': ordering })
                    .then((response) => {
                        if(response.ok) {
                            Tracking.trackEvent('Extras', 'sort', 'success', null);
                        } else {
                            console.log('order update failed');
                            Tracking.trackEvent('Extras', 'sort', 'failed', null);
                        }
                    }, () => {
                        console.log('order update failed');
                        Tracking.trackEvent('Extras', 'sort', 'failed', null);
                    });
            },
            addExtra() {
                let extra = {
                    description: null,
                    name: null,
                    applies_for_tent: true,
                    applies_for_camper: true,
                    applies_for_caravan: true,
                    applies_for_accommodation: true,
                    applies_for_camping: true,
                    transit_item: false,
                };
                if(this.tab === 1) {
                    extra.extra_type = 'mandatory';
                }
                Tracking.trackEvent('Extras', 'addExtra', null, null);
                this.extras.push(extra);
                // scroll to position of added element which in this case is end of page
                setTimeout(() => {
                    document.body.scrollTop = this.$el.scrollHeight;
                }, 0);
            },
            deleteExtra() {
                Api.extras.deleteExtra(this.modal.extra)
                    .then((response) => {
                        if(Math.floor(response.status / 100) === 2) {
                            this.extras.splice(this.modal.index, 1);
                            Api.bootstrap(true);
                            EventBus.$emit(EventBus.UPDATE_CHECKS);
                            Tracking.trackEvent('Extras', 'delete', 'success', null);
                        } else {
                            console.error('delete failed', response);
                            EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                                title: 'Das Extra konnte nicht gelöscht werden',
                                body: response.body.message,
                                type: 'danger',
                                direction: 'Up',
                                duration: 5000,
                            });
                            Tracking.trackEvent('Extras', 'delete', 'failed', null);
                        }
                    }, (response) => {
                        console.log('delete failed', response);
                        Tracking.trackEvent('Extras', 'delete', 'failed', null);
                    });
                this.closeModal();
            },

            openModal(index) {
                if(!this.extras[index].id) {
                    this.extras.splice(index, 1);
                    Tracking.trackEvent('Extras', 'discardUnsaved', null, null);
                    return;
                }
                // if season is saved season, show warning modal
                this.modal.title = this.$t('generic.warning');
                this.modal.content = this.$t('generic.modal.delete', { name: this.extras[index].name });
                this.modal.isActive = true;
                this.modal.extra = this.extras[index];
                this.modal.index = index;
            },

            closeModal() {
                this.modal.isActive = false;
            },

            nextStepClicked() {
                Tracking.trackEvent('Extras', 'nextStep', 'settings', null);
            }
        },
    };
</script>

<style lang="scss">
    @import './extras.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/extras/extras.vue